import React, { useMemo } from 'react';
import { Compare } from '@navi-toolbox/ui-components';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'fronton-react';
import { useBreakpoints } from 'common/hooks';

export const PdpComparison: React.FC = () => {
  const [isActive, setActive] = React.useState(false);
  const breakpoints = useBreakpoints();
  const isDesktop = useMemo(() => breakpoints?.largeDesktop || breakpoints?.desktop, [breakpoints]);
  const { t } = useTranslation();

  const tipText = isActive ? t('ui.buttons.compare-tooltip-remove') : t('ui.buttons.compare-tooltip-add');
  const button = (
    <Compare onClick={() => setActive(!isActive)} buttonText={t('ui.buttons.compare')} active={isActive} />
  );

  return isDesktop ? (
    <Tooltip placement="top" title={tipText}>
      {button}
    </Tooltip>
  ) : (
    <>{button}</>
  );
};
